import {
  AppsOutlined,
  MenuOpenOutlined,
  MenuOutlined,
  SettingsOutlined
} from "@material-ui/icons";
import { LogoutOutlined, Person2Outlined } from "@mui/icons-material";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import Diversity2OutlinedIcon from "@mui/icons-material/Diversity2Outlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import {
  Avatar,
  Fade,
  Grid,
  Menu,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import MuiDrawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled, useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import { jwtDecode } from "jwt-decode";
import * as React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getBackendProfilePictureLink } from "../../../Helpers/utilsHelper";
import AdminRoutes from "../../../route/AdminRoutes";
import AuthService from "../../../service/AuthService";
import { FID_LOGO, FID_LOGO_MINI, public_url } from "../DrawerAppBar";
import Footer from "../Footer";
import AppBreadcrumbs from "../shares/AppBreadcrumbs";
import ScrollToTopButton from "../shares/ScrollToTopButton";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `0px`,
  //   width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 0,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function MiniDrawer() {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const url = useLocation();
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [connectedUser, setConnectedUser] = React.useState({});
  const [userIsAdmin, setUserIsAdmin] = React.useState(false);
  const navigate = useNavigate();

  const [anchorElAvatar, setAnchorElAvatar] = React.useState(null);
  const openAvatarMenu = Boolean(anchorElAvatar);
  const handleClickAvatarMenu = (event) => {
    setAnchorElAvatar(event.currentTarget);
  };
  const handleCloseAvatarMenu = () => {
    setAnchorElAvatar(null);
  };

  const personalSideBarMenu = [
    /* {
      titre: "Tableau de bord",
      link: "/administration/dashboard",
      icon: <DashboardCustomizeOutlinedIcon />,
    }, */
    {
      titre: "Agences gérées",
      link: "administration/agences-gerees",
      icon: <Diversity2OutlinedIcon />,
    },
    {
      titre: "Recrutement",
      link: "/administration/recrutement",
      icon: <WorkOutlineOutlinedIcon />,
    },
  ];
  const parametrageMenu = [
    {
      titre: "Parametrage",
      link: "/administration/parametrage",
      icon: <SettingsOutlined />,
    },
    {
      titre: "Administrateurs",
      link: "/administration/administrateurs",
      icon: <AdminPanelSettingsOutlinedIcon />,
    },
    /* {
      titre: "Mon compte",
      link:"/administration/mon-profile",
      icon: <PersonOutline />,
    }, */
  ];

  const extraBotomMenu = [
    {
      titre: "Aides",
      link: "/administration/help",
      icon: <HelpOutlineOutlinedIcon />,
    },
  ];

  const settingsUserMenu = [
    {
      titre: "Mon Profile",
      link: process.env.PUBLIC_URL + "/administration/mon-profile",
      icon: <Person2Outlined />,
    },
    {
      titre: "Deconnexion",
      link: "logout",
      icon: <LogoutOutlined />,
    },
  ];

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const toggleOpenDrawer = () => {
    setOpen(!open);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  // const isTokenCreatedToday = (token) => {
  //   try {
  //     const decoded = jwtDecode(token);

  //     if (!decoded.timestamp) return false;

  //     const tokenDate = new Date(decoded.timestamp * 1000);
  //     const today = new Date();

  //     return (
  //       tokenDate.getFullYear() === today.getFullYear() &&
  //       tokenDate.getMonth() === today.getMonth() &&
  //       tokenDate.getDate() === today.getDate()
  //     );
  //   } catch (error) {
  //     return false;
  //   }
  // };

  const getConnectedUser = () => {
    const token = localStorage.getItem("TOKEN");
    let userInfo = JSON.parse(localStorage.getItem("user")) || {};

    if (token) {
      const user = jwtDecode(token);
      if (!user) {
        handleLogout();
      }
      const isAdmin = String(user.scope).split(":")[1] === "7" || false;
      setUserIsAdmin(isAdmin);
      if (userInfo && isAdmin) {
        setConnectedUser(userInfo);
      } else {
        handleLogout();
      }
    }
  };

  const handleLogout = () => {
    AuthService.logOut();
    setConnectedUser({});
    setAnchorElUser(null);
    navigate("/");
    window.location.reload();
  };

  React.useEffect(() => {
    getConnectedUser();
    if (!AuthService.isConnected() && !public_url.includes(url.pathname)) {
      const redirect = encodeURIComponent(
        `${url.pathname}${url.search || ""}${url.hash || ""}`
      );
      navigate(`/login?rdr=${redirect}`);
    }
    if (url.pathname.split("/").includes("logout")) {
      handleLogout();
    }
  }, [url.pathname, navigate]);

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open} color="inherit" elevation={0}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={[
                {
                  marginRight: 5,
                },
                open && { display: "none" },
              ]}
            >
              <MenuIcon />
            </IconButton>
            <Box
              width={"100%"}
              alignItems={"center"}
              display={"flex"}
              justifyContent={"space-between"}
              flexDirection={"row-reverse"}
            >
              <Grid>
                <Grid container spacing={3} alignItems={"center"}>
                  <Grid item>
                    <Tooltip title={"Aucune notification"}>
                      <IconButton
                        onClick={handleOpenUserMenu}
                        sx={{ p: 0 }}
                        size="large"
                      >
                        <NotificationsOutlinedIcon
                          color="inherit"
                          fontSize="medium"
                        />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <IconButton
                      title={connectedUser.full_name}
                      /* onClick={handleOpenUserMenu} */ sx={{ p: 0 }}
                      id="fade-button"
                      aria-controls={openAvatarMenu ? "fade-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openAvatarMenu ? "true" : undefined}
                      onClick={handleClickAvatarMenu}
                    >
                      <Avatar
                        sx={{
                          width: "35px",
                          height: "35px",
                          border: "1px solid #b9b9b9ff",
                        }}
                        alt={connectedUser.full_name || "User"}
                        src={getBackendProfilePictureLink(connectedUser.photo)}
                      />
                    </IconButton>
                    <Menu
                      id="fade-menu"
                      slotProps={{
                        list: {
                          "aria-labelledby": "fade-button",
                        },
                      }}
                      slots={{ transition: Fade }}
                      anchorEl={anchorElAvatar}
                      open={openAvatarMenu}
                      onClose={handleCloseAvatarMenu}
                    >
                      {settingsUserMenu.map((setting, index) => (
                        <ListItemButton
                          to={setting.link}
                          key={index}
                          disabled={url.pathname.includes(setting.link)}
                          onClick={handleCloseAvatarMenu}
                        >
                          {setting.icon}
                          <ListItemText
                            sx={{ pl: 3 }}
                            primary={setting.titre}
                          />
                        </ListItemButton>
                      ))}
                    </Menu>
                  </Grid>
                </Grid>
              </Grid>
              <Box display={"flex"} alignItems={"center"}>
                <IconButton onClick={toggleOpenDrawer}>
                  {/* {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />} */}
                  {open ? (
                    <MenuOpenOutlined />
                  ) : (
                    <MenuOutlined
                      style={{
                        display: (!isMdUp && "none") || "block",
                      }}
                    />
                  )}
                </IconButton>{" "}
                <Box ml={1.5} sx={{ display: { xs: "none", sm: "block" } }}>
                  <AppBreadcrumbs default_home_link="/administration" />
                </Box>
              </Box>
            </Box>
          </Toolbar>
          {/* <Divider /> */}
        </AppBar>
        <Drawer variant="permanent" open={open} elevation={1}>
          <DrawerHeader>
            {/* <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                display: { xs: "none", sm: "none", md: "block" },
              }}
              textAlign={"center"}
            >
            </Typography> */}
            {open ? (
              <Grid width={"100%"} textAlign={"center"}>
                {FID_LOGO}
              </Grid>
            ) : (
              <Grid pl={1} width={"100%"} textAlign={"center"}>
                <Grid item>{FID_LOGO_MINI}</Grid>
              </Grid>
            )}
          </DrawerHeader>
          <Divider />
          <List>
            {personalSideBarMenu.map((item, index) => (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  title={item.titre}
                  component={Link}
                  to={item.link}
                  sx={[
                    {
                      minHeight: 48,
                      px: 2.5,
                    },
                    open
                      ? {
                          justifyContent: "initial",
                        }
                      : {
                          justifyContent: "center",
                        },
                    {
                      color: url.pathname.includes(item.link)
                        ? "primary.main"
                        : "text.primary",
                      borderLeft: url.pathname.includes(item.link)
                        ? "2px solid #1976d2"
                        : "none",
                      borderRight: url.pathname.includes(item.link)
                        ? "2px solid #1976d2"
                        : "none",
                      bgcolor: url.pathname.includes(item.link)
                        ? "rgba(25, 118, 210, 0.10)"
                        : "transparent",
                    },
                  ]}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                      },
                      open
                        ? {
                            mr: 3,
                          }
                        : {
                            mr: "auto",
                          },
                      {
                        color: url.pathname.includes(item.link)
                          ? "primary.main"
                          : "text.primary",
                      },
                    ]}
                  >
                    {item.icon ? item.icon : <AppsOutlined />}
                  </ListItemIcon>
                  <ListItemText
                    color="text.primary"
                    primary={item.titre}
                    sx={[
                      open
                        ? {
                            opacity: 1,
                          }
                        : {
                            opacity: 0,
                          },
                    ]}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            {parametrageMenu.map((item, index) => (
              <ListItem key={index} disablePadding sx={{ display: "block" }}>
                <ListItemButton
                  component={Link}
                  title={item.titre}
                  to={item.link}
                  sx={[
                    {
                      minHeight: 48,
                      px: 2.5,
                    },
                    open
                      ? {
                          justifyContent: "initial",
                        }
                      : {
                          justifyContent: "center",
                        },
                    {
                      color: url.pathname.includes(item.link)
                        ? "primary.main"
                        : "text.primary",
                      borderLeft: url.pathname.includes(item.link)
                        ? "2px solid #1976d2"
                        : "none",
                      borderRight: url.pathname.includes(item.link)
                        ? "2px solid #1976d2"
                        : "none",
                      bgcolor: url.pathname.includes(item.link)
                        ? "rgba(25, 118, 210, 0.10)"
                        : "transparent",
                    },
                  ]}
                >
                  <ListItemIcon
                    sx={[
                      {
                        minWidth: 0,
                        justifyContent: "center",
                      },
                      open
                        ? {
                            mr: 3,
                          }
                        : {
                            mr: "auto",
                          },
                      {
                        color: url.pathname.includes(item.link)
                          ? "primary.main"
                          : "text.primary",
                      },
                    ]}
                  >
                    {item.icon ? item.icon : <AppsOutlined />}
                  </ListItemIcon>
                  <ListItemText
                    primary={item.titre}
                    sx={[
                      open
                        ? {
                            opacity: 1,
                          }
                        : {
                            opacity: 0,
                          },
                    ]}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Grid flexGrow={1} alignContent={"flex-end"}>
            {/* <Divider /> */}
            <List sx={{ bottom: 1 }}>
              {extraBotomMenu.map((item, index) => (
                <ListItem key={index} disablePadding sx={{ display: "block" }}>
                  <ListItemButton
                    component={Link}
                    title={item.titre}
                    to={item.link}
                    sx={[
                      {
                        minHeight: 48,
                        px: 2.5,
                      },
                      open
                        ? {
                            justifyContent: "initial",
                          }
                        : {
                            justifyContent: "center",
                          },
                      {
                        color: url.pathname.includes(item.link)
                          ? "primary.main"
                          : "text.primary",
                        borderLeft: url.pathname.includes(item.link)
                          ? "2px solid #1976d2"
                          : "none",
                        borderRight: url.pathname.includes(item.link)
                          ? "2px solid #1976d2"
                          : "none",
                        bgcolor: url.pathname.includes(item.link)
                          ? "rgba(25, 118, 210, 0.10)"
                          : "transparent",
                      },
                    ]}
                  >
                    <ListItemIcon
                      sx={[
                        {
                          minWidth: 0,
                          justifyContent: "center",
                        },
                        open
                          ? {
                              mr: 3,
                            }
                          : {
                              mr: "auto",
                            },
                        {
                          color: url.pathname.includes(item.link)
                            ? "primary.main"
                            : "text.primary",
                        },
                      ]}
                    >
                      {item.icon ? item.icon : <AppsOutlined />}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.titre}
                      sx={[
                        open
                          ? {
                              opacity: 1,
                            }
                          : {
                              opacity: 0,
                            },
                      ]}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Grid>
        </Drawer>
        <Box
          component="main"
          sx={{
            bgcolor: "rgba(248, 248, 250, 1)",
            height: "100vh",
            flexGrow: 1,
            p: 3,
            zIndex: 0,
          }}
        >
          <Box>
            <AppBreadcrumbs defaultTitle="FID Admin" display={false} />
          </Box>
          <DrawerHeader />
          <AdminRoutes />

          <Grid mt={5} textAlign={"center"} flexGrow={1}>
            <Footer />
          </Grid>
        </Box>
      </Box>
      <ScrollToTopButton />
    </>
  );
}
